import _updateContentMetaIndex from 'rlink-router/actions/_updateContentMetaIndex';
import _updateMessages from 'rlink-router/actions/_updateMessages';
import getContentMetaIndex from 'rlink-router/getContentMetaIndex';
import loadLocale from 'rlink-router/loadLocale';
import animationFrame from 'rlink-await-animation-frame';

export default function _loadView (buildContext, view, params = {}) {
  let {locale = buildContext.defaultLocale} = params;
  return (dispatch, getState) => Promise.all([
    buildContext.loadViewFn(view),
    buildContext.ensureContentMetaIndexFor(
      getContentMetaIndex(getState().routing), view, params
    ).then(async contentMetaIndex => {
      await animationFrame();
      dispatch(_updateContentMetaIndex(contentMetaIndex));
      return buildContext.contentForView(contentMetaIndex, view, params);
    }),
    loadLocale(buildContext, locale),
    buildContext.loadMessages(view, params).then(async messages => {
      await animationFrame();
      dispatch(_updateMessages(locale, messages));
    }),
  ]).then(async ([viewFn, viewContent, _loc, _msg]) => {
    for (let [contentKey, content] of Object.entries(viewContent)) {
      if (!content) {
        return Promise.reject({missingContent: contentKey});
      }
    }
    await animationFrame();
    return viewFn(params, viewContent);
  });
}



// WEBPACK FOOTER //
// ./lib/rlink-router/actions/_loadView.js